'use client'

import Link from 'next/link'
import { Icon } from '@/components/icon'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { capture } from '@/features/tracking'

function getTierLabel(privilegeLevel: number) {
  if (privilegeLevel >= 3) return 'Elite Access'
  if (privilegeLevel >= 2) return 'Premium Access'
  if (privilegeLevel >= 1) return 'Standard Access'
  return 'Free Access'
}

export function AccessQualityBadge({ privilegeLevel }: { privilegeLevel: number }) {
  const hasHdAccess = privilegeLevel > 0
  const showTierBadge = privilegeLevel > 0
  const tierLabel = showTierBadge ? getTierLabel(privilegeLevel) : null

  return (
    <div className='inline-flex items-center gap-2'>
      {tierLabel ? (
        <span className='inline-flex items-center rounded-sm border border-christ-red/60 bg-christ-red/20 px-3 py-1 font-semibold text-christ-red text-xs uppercase tracking-[0.06rem] backdrop-blur-md'>
          {tierLabel}
        </span>
      ) : null}

      {hasHdAccess ? (
        <span className='inline-flex cursor-default items-center rounded-full border border-white/15 bg-white/5 px-2.5 py-1 font-semibold text-[0.7rem] text-white uppercase tracking-[0.08rem] backdrop-blur-md'>
          4K
        </span>
      ) : (
        <div className='inline-flex items-center gap-1.5'>
          <span className='inline-flex cursor-default items-center rounded-full border border-white/30 bg-white/15 px-2.5 py-1 font-semibold text-[0.7rem] text-white uppercase tracking-[0.08rem] backdrop-blur-md'>
            720p
          </span>

          <Tooltip>
            <TooltipTrigger asChild>
              <Link
                href='/pay-it-forward'
                onClick={() => {
                  capture('donation:pay_it_forward_modal_view', {
                    trigger_point: 'watch',
                  })
                }}
                className='inline-flex items-center gap-1.5 rounded-full border border-white/25 border-dashed bg-white/8 px-2.5 py-1 font-semibold text-[0.7rem] text-white/70 uppercase tracking-[0.08rem] backdrop-blur-md transition-colors hover:bg-white/12 hover:text-white'
              >
                <Icon name='lock' className='size-3 text-white/65' />
                <span>4K</span>
              </Link>
            </TooltipTrigger>
            <TooltipContent sideOffset={8} className='max-w-56'>
              <span>Unlock HD film (up to 4K) by paying it forward.</span>
            </TooltipContent>
          </Tooltip>
        </div>
      )}
    </div>
  )
}
